export default "__VITE_ASSET__Bg9pgZup__"